<template>
    <div class="page noScroll">
        <div class="page-content infinite-scroll noScroll">
            <Contact :nationTip="userInfo.nationality === '中国' ? '必填' : '选填'" @on-save="save"></Contact>
        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import Contact from '@/components/Contact'
    import { isChinese, isLetter, checkTel, checkMail, checkPassport } from '@/utilities/tools'
    export default {
        name: 'ContactCreate',
        components: {
            Contact
        },
        data () {
            return {
                userToken: '',
                userInfo: {}
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '常用联系人')
            this.$store.dispatch('HIDE_HEADER_BAR', {isHideFooter: true})
            this.showPage()
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                const userToken = this.$store.state.user.userToken
                if (!userToken && userToken.length == 0) {
                    this.$router.push(`/Orchard.Rccl.Users/Login/Login?returnUrl=${encodeURIComponent(window.location.pathname)}`)
                    return
                }
                this.userToken = userToken
                this.userInfo = await this.getEditInfo(this.userToken)
            },
            async getEditInfo (userName) {
                const {success, data, errMsg} = await api.user.userEditInfo(userName)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            getCountryArea(country){
              return country==="CN" ||
                  country === "HK" ||
                  country === "MAC" ||
                  country === "TWN";
            },
            async save (data) {
                let contact = data
                let isCN = this.getCountryArea(contact.country)
                if (!contact.country && this.userInfo.nationality === '中国') {
                    this.$alert.show('请选择国家或地区')
                    return false
                }
                if(isCN){
                  if (!contact.chineseLastName) {
                    this.$alert.show('请输入中文姓')
                    return false
                  }

                  if (!contact.chineseFirstName) {
                    this.$alert.show('请输入中文名')
                    return false
                  }

                  if (!isChinese(contact.chineseLastName)
                      || !isChinese(contact.chineseFirstName)) {
                    this.$alert.show('请输入正确的中文姓或中文名')
                    return false
                  }
                }


                if (!contact.pinYinLastName) {
                    this.$alert.show('请输入拼音姓')
                    return false
                }

                if (!contact.pinYinFirstName) {
                    this.$alert.show('请输入拼音名')
                    return false
                }

                if (!isLetter(contact.pinyinLastName)
                || !isLetter(contact.pinyinFirstName)) {
                    this.$alert.show('请输入正确的拼音姓或拼音名')
                    return false
                }

                if (!contact.gender) {
                    this.$alert.show('请选择性别')
                    return false
                }

                if (!contact.dateOfBirth) {
                    this.$alert.show('请输入出生日期')
                    return false
                }

                if (contact.email && contact.email.length > 0
                && !checkMail(contact.email)) {
                    this.$alert.show('请输入正确的邮箱');
                    return false;
                }

                if (contact.telephone && contact.telephone.length > 0
                && !checkTel(contact.telephone)) {
                    this.$alert.show('请输入正确的手机号码');
                    return false;
                }

                if (contact.passportNum && contact.passportNum.length > 0
                && !checkPassport(contact.passportNum)) {
                    this.$alert.show('请输入正确的护照号');
                    return false;
                }

                if(contact.updateFields.includes("ChineseFirstName") && !contact.updateFields.includes("PinYinFirstName")) {
                  contact.updateFields.push("PinYinFirstName")
                }

                if(!contact.updateFields.includes("ChineseLastName") || !contact.updateFields.includes("PinYinLastName")) {
                  contact.updateFields.push("PinYinLastName")
                }
                // 提交信息
                await this.createContact(contact)

                // 返回列表页
                this.$router.push('/Rccl.UserCenter/UserContact/List')
            },
            async createContact (contact) {
                this.$loading.show()
                const {success, data, errMsg} = await api.user.createContact(contact)
                if (!success) {
                    this.$alert.show(errMsg)
                } else {
                    console.log(data)
                }
                this.$loading.hide()
            }
        }
    }
</script>

<style scoped>
    .page {
        display: block;
        background: #F6F7F8 !important;
    }
    .page-content{
        padding-bottom: 100px;
    }
</style>
